<div class="seguimiento-container">

  <div class="page-header">

    <div class="page-title-container">

      <div class="page-icon"><i class="fi fi-rr-filter"></i></div>

      <div>

        <h1>Seguimiento de contrataciones</h1>

        <p>Revisa el avance de las inscripciones iniciadas por convenio y contacta directamente a quienes quedaron pendientes.</p>

      </div>

    </div>

    <div class="header-actions">

      <button type="button" class="btn btn-outline-primary btn-exportar"
              [disabled]="!contratacionesFiltradas.length"
              (click)="exportarCSV()">
        <i class="fi fi-rr-download"></i>
        Exportar
      </button>

      <button type="button" class="btn btn-primary btn-nueva-inscripcion" routerLink="/inscripcion-convenio-ejecutivo">

        <i class="fi fi-rr-plus"></i> Nueva inscripción asistida

      </button>

    </div>

  </div>

  <div class="card filtro-card">

    <div class="filtro-row">

      <div class="filtro-label">

        <i class="fi fi-rr-building"></i>

        <span>CLIENTE</span>

      </div>

      <div class="filtro-content">

        <select class="form-control cliente-select"

                [(ngModel)]="clienteSeleccionado"

                (change)="onClienteChange()"

                [disabled]="cargandoClientes || clientes.length === 0">

          <option [ngValue]="null" disabled>

            {{ cargandoClientes ? 'Cargando clientes...' : 'Seleccione un cliente' }}

          </option>

          <option *ngFor="let cliente of clientes" [ngValue]="cliente.cus_id">

            {{ cliente.cus_name }}

          </option>

        </select>

      </div>

    </div>

    <div class="separator"></div>

    <div class="filtro-row periodo-row">

      <div class="filtro-label">

        <i class="fi fi-rr-calendar"></i>

        <span>PERIODO</span>

      </div>

      <div class="periodos-container">

        <button *ngFor="let periodo of periodos"

                type="button"

                class="periodo-chip"

                [class.active]="periodoSeleccionado === periodo.id"

                (click)="seleccionarPeriodo(periodo.id)">

          {{ periodo.nombre }}

        </button>

      </div>

    </div>

    <div class="fechas-row">

      <div class="fecha-field">

        <label>DESDE</label>

        <input type="date"

               class="form-control"

               [(ngModel)]="fechaDesdeTemporal"

               (change)="onFechaChange()"

               [disabled]="periodoSeleccionado !== 'custom'">

      </div>

      <div class="fecha-separator">–</div>

      <div class="fecha-field">

        <label>HASTA</label>

        <input type="date"

               class="form-control"

               [(ngModel)]="fechaHastaTemporal"

               (change)="onFechaChange()"

               [disabled]="periodoSeleccionado !== 'custom'">

      </div>

      <button type="button"

              class="btn btn-aplicar"

              [class.pending]="fechasPendientes"

              [disabled]="periodoSeleccionado !== 'custom'"

              (click)="aplicarFechas()">

        Aplicar

      </button>

      <span *ngIf="periodoSeleccionado === 'custom' && fechasPendientes" class="cambios-pendientes">

        <i class="fi fi-rr-clock"></i> Cambios sin aplicar

      </span>

    </div>

    <div *ngIf="resumenPeriodo" class="periodo-resumen">

      <i class="fi fi-rr-check"></i>

      <span>{{ resumenPeriodo }}</span>

    </div>

    <div *ngIf="mensajeError" class="alert alert-danger mt-3 mb-0">{{ mensajeError }}</div>

    <div class="buscar-row">

      <button type="button"

              class="btn btn-primary btn-ver-seguimiento"

              [disabled]="cargandoClientes || cargandoSeguimiento || !clienteSeleccionado"

              (click)="verSeguimiento()">

        <i *ngIf="!cargandoSeguimiento" class="fi fi-rr-search"></i>

        <span *ngIf="cargandoSeguimiento" class="spinner-border spinner-border-sm mr-1"></span>

        {{ cargandoSeguimiento ? 'Cargando...' : 'Ver seguimiento' }}

      </button>

    </div>

  </div>

  <ng-container *ngIf="seguimientoCargado">

    <div class="kpi-grid">

      <div class="kpi-card">

        <div class="kpi-title"><i class="fi fi-rr-document"></i> Formularios iniciados</div>

        <div class="kpi-value">{{ totalFormularios }}</div>

        <div class="kpi-description">{{ textoPeriodoCorto }}</div>

      </div>

      <div class="kpi-card">

        <div class="kpi-title"><i class="fi fi-rr-clock"></i> En curso</div>

        <div class="kpi-value">{{ totalEnCurso }}</div>

        <div class="kpi-description">{{ textoPeriodoCorto }}</div>

      </div>

      <div class="kpi-card">

        <div class="kpi-title"><i class="fi fi-rr-check"></i> Completados</div>

        <div class="kpi-value kpi-green">{{ totalCompletados }}</div>

        <div class="kpi-description">{{ textoPeriodoCorto }}</div>

      </div>

      <div class="kpi-card">

        <div class="kpi-title"><i class="fi fi-rr-pause-circle"></i> Olvidados</div>

        <div class="kpi-value">{{ totalOlvidados }}</div>

        <div class="kpi-description">Sin terminar, con carrito activo</div>

      </div>

      <!-- <div class="kpi-card">

        <div class="kpi-title"><i class="fi fi-rr-triangle-warning"></i> Caducados</div>

        <div class="kpi-value kpi-red">{{ totalCaducados }}</div>

        <div class="kpi-description">El plan cambió de precio o fecha</div>

      </div> -->

    </div>

    <div class="tabs-flujo">

      <button type="button" [class.active]="tabFlujo === 'todos'" (click)="seleccionarTab('todos')">Todos</button>

      <button type="button" [class.active]="tabFlujo === 'directa'" (click)="seleccionarTab('directa')">Directa</button>

      <button type="button" [class.active]="tabFlujo === 'asistido'" (click)="seleccionarTab('asistido')">Asistido por ejecutivo</button>

    </div>

    <div class="table-filters">

      <div class="search-box">

        <i class="fi fi-rr-search"></i>

        <input type="text"

               [(ngModel)]="searchText"

               (ngModelChange)="onFiltroChange()"

               placeholder="Buscar por nombre o RUT...">

      </div>

      <select class="form-control" [(ngModel)]="filtroEstado" (change)="onFiltroChange()">

        <option value="">Todos los estados</option>

        <option value="En curso">En curso</option>

        <option value="Completado">Completado</option>

        <option value="Olvidado">Olvidado</option>

        <option value="Caducado">Caducado</option>

      </select>

      <select class="form-control" [(ngModel)]="filtroPaso" (change)="onFiltroChange()">

        <option value="">Cualquier paso alcanzado</option>

        <option value="3">Paso 3 - Beneficiarios</option>

        <option value="4">Paso 4 - Pago</option>

        <option value="5">Paso 5 - Completado</option>

      </select>

      <select class="form-control" [(ngModel)]="filtroEjecutivo" (change)="onFiltroChange()">

        <option value="">Todos los ejecutivos</option>

        <option *ngFor="let ejecutivo of ejecutivosDisponibles" [value]="ejecutivo">{{ ejecutivo }}</option>

      </select>

    </div>

    <div class="table-card">

      <div class="table-responsive">

        <table class="table seguimiento-table">

          <thead>

            <tr>

              <th>TITULAR</th>

              <th>FLUJO</th>

              <th>EJECUTIVO</th>

              <th>FECHA DE INICIO</th>

              <th>PASO ALCANZADO</th>

              <th>ESTADO</th>

              <th>ÚLTIMA ACTIVIDAD ▲</th>

              <th>CONTACTO</th>

              <th class="acciones-col"></th>

            </tr>

          </thead>

          <tbody>

            <tr *ngFor="let item of contratacionesPaginadas" (click)="abrirDetalle(item)">

              <td>

                <div class="titular-name">{{ getTitularNombre(item) }}</div>

                <div class="titular-rut">{{ getTitularRut(item) }}</div>

              </td>

              <td>

                <span class="flujo-badge" [class.asistido]="getFlujo(item) === 'Asistido'">

                  {{ getFlujo(item) }}

                </span>

              </td>

              <td>{{ getEjecutivo(item) }}</td>

              <td>{{ getFechaInicio(item) }}</td>

              <td>

                <div class="paso-container">

                  <div class="paso-dots">

                    <span *ngFor="let paso of [1,2,3,4,5]"

                          [class.done]="paso <= getPasoNumero(item)"

                          [class.error]="paso === getPasoNumero(item) && getEstadoSeguimiento(item) === 'Caducado'">

                    </span>

                  </div>

                  <span>{{ getPasoTexto(item) }}</span>

                </div>

              </td>

              <td>

                <span class="estado-badge" [ngClass]="getEstadoClass(item)">

                  {{ getEstadoSeguimiento(item) }}

                </span>

              </td>

              <td>{{ getUltimaActividadTexto(item) }}</td>

              <td>

                <div class="contact-buttons">

                  <a *ngIf="getTitularTelefono(item)"

                     class="icon-btn"

                     [href]="'tel:' + getTitularTelefono(item)"

                     (click)="$event.stopPropagation()"

                     title="Llamar">

                    <i class="fi fi-rr-headset"></i>

                  </a>

                  <a *ngIf="getTitularEmail(item)"

                     class="icon-btn"

                     [href]="'mailto:' + getTitularEmail(item)"

                     (click)="$event.stopPropagation()"

                     title="Enviar correo">

                    <i class="fi fi-rr-envelope"></i>

                  </a>

                </div>

              </td>

              <td class="acciones-col">

                <button type="button"

                        class="icon-btn"

                        (click)="$event.stopPropagation(); abrirDetalle(item)"

                        title="Ver detalle">

                  <i class="fi fi-rr-eye"></i>

                </button>

              </td>

            </tr>

            <tr *ngIf="contratacionesPaginadas.length === 0">

              <td colspan="9" class="empty-row">No existen contrataciones para los filtros seleccionados.</td>

            </tr>

          </tbody>

        </table>

      </div>

      <div class="table-footer">

        <div>

          {{ firstVisibleItem }} - {{ lastVisibleItem }} de {{ totalFiltradas }} contrataciones ·

          Convenio {{ clienteNombreSeleccionado }} · {{ textoPeriodoCorto }}

        </div>

        <div class="pagination-custom" *ngIf="totalFiltradas > 0">

          <button type="button" [disabled]="currentPage === 1" (click)="previousPage()">‹ Anterior</button>

          <button *ngFor="let pagina of paginasVisibles"

                  type="button"

                  class="page-number"

                  [class.active]="pagina === currentPage"

                  (click)="irPagina(pagina)">

            {{ pagina }}

          </button>

          <button type="button" [disabled]="currentPage === totalPages" (click)="nextPage()">Siguiente ›</button>

        </div>

      </div>

    </div>

  </ng-container>

</div>

<div class="drawer-overlay" *ngIf="mostrarDetalle" (click)="cerrarDetalle()">

  <div class="drawer-panel" (click)="$event.stopPropagation()" *ngIf="detalleSeleccionado">

    <div class="drawer-header">

      <div>

        <h2>{{ getTitularNombre(detalleSeleccionado) }}</h2>

        <div class="drawer-subtitle">

          {{ getTitularRut(detalleSeleccionado) }}

          <span class="flujo-badge" [class.asistido]="getFlujo(detalleSeleccionado) === 'Asistido'">

            {{ getFlujo(detalleSeleccionado) }}

          </span>

        </div>

      </div>

      <button type="button" class="drawer-close" (click)="cerrarDetalle()">

        <i class="fi fi-rr-cross"></i>

      </button>

    </div>

    <div class="drawer-content">

      <div class="detail-card">

        <div class="detail-title">ESTADO ACTUAL</div>

        <span class="estado-badge" [ngClass]="getEstadoClass(detalleSeleccionado)">

          {{ getEstadoSeguimiento(detalleSeleccionado) }}

        </span>

        <p class="detail-description">{{ getDescripcionEstado(detalleSeleccionado) }}</p>

      </div>

      <div class="detail-card">

        <div class="detail-title">CONTACTO DIRECTO</div>

        <p class="detail-help">Comunícate tú mismo con el titular — no se envían mensajes desde este panel.</p>

        <a *ngIf="getTitularTelefono(detalleSeleccionado)"

           class="detail-contact"

           [href]="'tel:' + getTitularTelefono(detalleSeleccionado)">

          <i class="fi fi-rr-headset"></i>

          {{ getTitularTelefono(detalleSeleccionado) }}

        </a>

        <a *ngIf="getTitularEmail(detalleSeleccionado)"

           class="detail-contact"

           [href]="'mailto:' + getTitularEmail(detalleSeleccionado)">

          <i class="fi fi-rr-envelope"></i>

          {{ getTitularEmail(detalleSeleccionado) }}

        </a>

      </div>

      <div class="detail-card">

        <div class="detail-title">DATOS DE LA INSCRIPCIÓN</div>

        <div class="detail-data-grid">

          <div>

            <span>Fecha de inicio</span>

            <strong>{{ getFechaInicio(detalleSeleccionado) }}</strong>

          </div>

          <div>

            <span>Última actividad</span>

            <strong>{{ getUltimaActividadTexto(detalleSeleccionado) }}</strong>

          </div>

          <div>

            <span>Plan</span>

            <strong>{{ getPlanNombre(detalleSeleccionado) }}</strong>

          </div>

          <div>

            <span>Beneficiarios</span>

            <strong>{{ getBeneficiarios(detalleSeleccionado) }}</strong>

          </div>

          <div>

            <span>Ejecutivo</span>

            <strong>{{ getEjecutivo(detalleSeleccionado) }}</strong>

          </div>

        </div>

      </div>

      <div class="detail-card">

        <div class="detail-title">AVANCE DEL PROCESO</div>

        <div class="timeline-item">

          <span class="timeline-dot" [ngClass]="getPasoTimelineClass(detalleSeleccionado, 1)">

            <i class="fi fi-rr-check"></i>

          </span>

          <div>

            <strong>Selección de plan</strong>

            <span>{{ getPasoTimelineTexto(detalleSeleccionado, 1) }}</span>

          </div>

        </div>

        <div class="timeline-item">

          <span class="timeline-dot" [ngClass]="getPasoTimelineClass(detalleSeleccionado, 2)">

            <i class="fi fi-rr-check"></i>

          </span>

          <div>

            <strong>Datos del titular</strong>

            <span>{{ getPasoTimelineTexto(detalleSeleccionado, 2) }}</span>

          </div>

        </div>

        <div class="timeline-item">

          <span class="timeline-dot" [ngClass]="getPasoTimelineClass(detalleSeleccionado, 3)">

            <i class="fi fi-rr-check"></i>

          </span>

          <div>

            <strong>Beneficiarios</strong>

            <span>{{ getPasoTimelineTexto(detalleSeleccionado, 3) }}</span>

          </div>

        </div>

        <div class="timeline-item">

          <span class="timeline-dot" [ngClass]="getPasoTimelineClass(detalleSeleccionado, 4)">

            <i class="fi fi-rr-check"></i>

          </span>

          <div>

            <strong>Pago</strong>

            <span>{{ getPasoTimelineTexto(detalleSeleccionado, 4) }}</span>

          </div>

        </div>

        <div class="timeline-item">

          <span class="timeline-dot" [ngClass]="getPasoTimelineClass(detalleSeleccionado, 5)">

            <i class="fi fi-rr-check"></i>

          </span>

          <div>

            <strong>Inscripción activa</strong>

            <span>{{ getPasoTimelineTexto(detalleSeleccionado, 5) }}</span>

          </div>

        </div>

      </div>

      <div class="detail-card comunicaciones-card"

     *ngIf="tieneComunicacionesAutomaticas(detalleSeleccionado)">

  <div class="detail-title">COMUNICACIONES AUTOMÁTICAS</div>

  <p class="detail-help">Se envían solo por mail.</p>

  <div class="comunicacion-item"

       *ngIf="esContratacionCompletada(detalleSeleccionado)">

    <div class="comunicacion-icon">

      <i class="fi fi-rr-envelope"></i>

    </div>

    <div class="comunicacion-info">

      <strong>Solicitud de inscripción enviada</strong>

      <span>{{ getFechaSolicitudInscripcion(detalleSeleccionado) }}</span>

    </div>

  </div>

  <div class="comunicacion-item"

       *ngIf="esContratacionOlvidada(detalleSeleccionado)">

    <div class="comunicacion-icon">

      <i class="fi fi-rr-envelope"></i>

    </div>

    <div class="comunicacion-info">

      <strong>Recordatorio de inscripción pendiente</strong>

      <span>{{ getFechaRecordatorioPendiente(detalleSeleccionado) }}</span>

    </div>

  </div>

</div>

    </div>

    <div class="drawer-footer">

      <button type="button" class="btn btn-outline-primary" (click)="cerrarDetalle()">Cerrar</button>

    </div>

  </div>

</div>
